module.exports = __webpack_public_path__ + "img/tarj1-3.e32b7580.svg";